module.exports = __webpack_public_path__ + "media/images/country_flags/mz-4b4a8913f8e80b757d9642c9f4b70b12.png";